// Form.tsx
import { SetStateAction } from 'react'
import { Button } from '../../../../../common/components/button/Button'
import { FileUpload } from '../../../../../common/components/fileUpload/FileUpload'
import { Input } from '../../../../../common/components/input/Input'
import { Textarea } from '../../../../../common/components/textarea/Textarea'
import { CategoryInterface } from '../../../../../common/types/interfaces'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { AttributeForm } from '../../../../../common/components/attributeForm/AttributeForm'
import { FieldTemplateForm } from '../../../../../common/components/fieldTemplateForm/FieldTemplateForm'
import { Toggle } from '../../../../../common/components/newToggle/Toggle'
import { SearchGroupSelect } from '../../../../../common/components/searchGroupSelect/SearchGroupSelect'

type Props = {
  edit: boolean
  data: CategoryInterface
  setData: React.Dispatch<SetStateAction<CategoryInterface>>
  getList: () => void
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  el?: CategoryInterface
}

export const Form = ({ edit, data, setData, getList, setModalActive, el }: Props) => {
  const {
    files,
    pairs,
    setFiles,
    setPairs,
    formAction,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    activeTab,
    setActiveTab,
    attrsDisabled,
    setAttrsDisabled,
    fieldsDisabled,
    setFieldsDisabled,
    createCategorySelectList,
    multipleSearchSelectHandler,
    multipleSearchSelectRemoveHandler,
  } = useForm(data, setData, edit, getList, setModalActive, el)

  return (
    <div className={classes.container}>
      <div className={classes.bookMarks}>
        <div
          className={activeTab === 'main' ? classes.titleActive : classes.title}
          onClick={() => setActiveTab('main')}
        >
          {data.id ? 'редактирование' : 'добавление'}
        </div>

        <div
          className={activeTab === 'attributes' ? classes.titleActive : classes.title}
          onClick={() => setActiveTab('attributes')}
        >
          {'параметры'}
        </div>

        {data.isComplex && (
          <div
            className={activeTab === 'fields' ? classes.titleActive : classes.title}
            onClick={() => setActiveTab('fields')}
          >
            {'поля'}
          </div>
        )}
      </div>

      {activeTab === 'attributes' && (
        <div className={classes.attributesContainer}>
          <AttributeForm
            setTopData={setData}
            topData={data}
            disabled={attrsDisabled}
            setDisabled={setAttrsDisabled}
          />
        </div>
      )}

      {activeTab === 'fields' && (
        <div className={classes.attributesContainer}>
          <FieldTemplateForm
            setTopData={setData}
            topData={data}
            disabled={fieldsDisabled}
            setDisabled={setFieldsDisabled}
          />
        </div>
      )}

      {activeTab === 'main' && (
        <>
          <Input
            type={'text'}
            fieldName={'name'}
            value={data.name}
            placeHolder={'Название категории'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('name')}
            onBlur={setDirty}
          />
          <Textarea
            type={'textarea'}
            fieldName={'description'}
            value={data.description}
            placeHolder="Опишите категорию подробно"
            rows={5}
            cols={20}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('description')}
            onBlur={setDirty}
          />

          <Input
            label="Порядок сортировки"
            type={'text'}
            fieldName={'sortOrder'}
            value={data.sortOrder}
            placeHolder={'Порядок сортировки'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('sortOrder')}
            onBlur={setDirty}
          />

          <div className={classes.toggleContainer}>
            <Toggle
              checked={data.isActive || false}
              onChange={() => setData((prev) => ({ ...prev, isActive: !prev.isActive }))}
            />
            <span className={classes.label}>Активна</span>
          </div>
          <div className={classes.toggleContainer}>
            <Toggle
              checked={data.isComplex || false}
              onChange={() => setData((prev) => ({ ...prev, isComplex: !prev.isComplex }))}
            />
            <span className={classes.label}>Комплексные товары</span>
          </div>

          <SearchGroupSelect
            onBlur={setDirty}
            fieldName="children"
            options={createCategorySelectList()}
            value={(data.children || []) as number[]}
            onChangeHandler={multipleSearchSelectHandler}
            onRemoveHandler={multipleSearchSelectRemoveHandler}
            itemValidationResult={getValidationResult('children')}
            type="array"
            placeholder={
              createCategorySelectList().length
                ? 'Начните ввод и выберите дочерние категории'
                : 'Сначала создайте категории'
            }
          />

          <FileUpload
            length={1}
            min_length={1}
            extensions={['jpeg', 'png', 'jpg', 'webp']}
            files={files}
            setFiles={setFiles}
            pairs={pairs}
            setPairs={setPairs}
          />
        </>
      )}

      <Button
        text={activeTab !== 'main' ? 'К сохранению' : edit ? 'Сохранить' : 'Добавить'}
        onClick={() => {
          if (activeTab !== 'main') {
            setActiveTab('main')
          } else {
            formAction()
          }
        }}
        disabled={
          (activeTab === 'main' && disabled) ||
          (activeTab === 'attributes' && attrsDisabled) ||
          (activeTab === 'fields' && fieldsDisabled)
        }
      />
    </div>
  )
}
